/**
 * Erinnerungsleiste "Konto verifizieren" — Markup und Sichtbarkeit: snippets/verify-reminder.liquid.
 *
 * Knopf: POST /api/b2b/verify-request mit {email, customerId} aus window.b2bConfig — derselbe
 * Aufruf wie die Karte im Konto (konto.js). Der Server prueft, dass der Aufrufer dieser Kunde
 * ist, und schickt hoechstens eine Mail in 24 h.
 *   Erfolg → gruene Bestaetigung, 'vr_requested_<id>' gesetzt: in diesem Browser nie wieder.
 *   "×"    → Pause nur fuer HEUTE und DIESE Anmeldung ('vr_snooze_<id>' = {tag, sitzung},
 *            gelesen im Snippet); nach dem Senden: einfach schliessen.
 *
 * ── window.B2BVerify (06.10.2026) ─────────────────────────────────────────────────────────
 * EINE Quelle fuer Leiste UND Konto-Karte. Vorher kannten beide nur das isUnverified aus
 * localStorage 'b2b_session' — eine Momentaufnahme vom Login, die nach der Freischaltung bis
 * zum naechsten Login stehen blieb. Leiste und Karte forderten so weiter zur Verifizierung
 * auf, und ein Klick eine Sekunde nach der Freischaltung legte eine neue Anfrage an (#13).
 *   status()      fragt den Server (nurStatus: legt nichts an, schickt nichts), hoechstens
 *                 einmal je Seite; ein "unverifiziert" gilt 5 min (sessionStorage), ein
 *                 "verifiziert" ist endgueltig.
 *   verifiziert   → Sitzung nachfuehren (isUnverified/isB2B/tags/company.verified), Merker
 *                 loeschen, Ereignis 'b2b:verifiziert' — Leiste und Karte verschwinden.
 *   angefragt     → 'vr_requested_<id>' setzen, Ereignis 'b2b:verify-angefragt' — beide zeigen
 *                 "gesendet", egal wo geklickt wurde.
 *   send()        der Knopf-Aufruf fuer beide; wertet auch alreadyVerified aus.
 * ⚠️ Das Snippet bindet diese Datei auf JEDER Seite ein, auch im Konto (dort ohne Leiste) —
 * konto.js laeuft spaeter im Dokument und findet window.B2BVerify vor.
 */
(function () {
  var API = 'https://pim.schaltschrank24.ch';
  var FRISCH_MS = 5 * 60 * 1000;
  var anfrage = null;

  function merke(key, wert) {
    try { localStorage.setItem(key, String(wert)); } catch (e) {}
  }
  function vergiss(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  function wer() {
    var cfg = window.b2bConfig || {};
    var s = null;
    try { s = JSON.parse(localStorage.getItem('b2b_session') || 'null'); } catch (e) {}
    // Ablauf wie im Snippet: eine abgelaufene Sitzung zaehlt nicht.
    if (s && s.expiresAt && !(new Date(s.expiresAt) > new Date())) s = null;
    var email = (s && s.email) || cfg.email || '';
    var id = (s && s.customerId) || cfg.customerId || '';
    return email && id ? { email: email, customerId: id, apiBase: cfg.apiBase || API } : null;
  }

  function melde(name, id) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: { customerId: id } })); } catch (e) {}
  }

  function alsVerifiziert(id) {
    try {
      var s = JSON.parse(localStorage.getItem('b2b_session') || 'null');
      if (s && String(s.customerId) === String(id)) {
        s.isUnverified = false;
        s.isB2B = true;
        s.tags = (s.tags || []).filter(function (t) { return t !== 'unverified'; });
        if (s.tags.indexOf('b2b') < 0) s.tags.push('b2b');
        s.company = s.company || {};
        s.company.verified = true;
        localStorage.setItem('b2b_session', JSON.stringify(s));
      }
    } catch (e) {}
    vergiss('vr_requested_' + id);
    vergiss('vr_snooze_' + id);
    try { sessionStorage.removeItem('vr_status_' + id); } catch (e) {}
    if (window.b2bConfig) window.b2bConfig.isUnverified = false;
    melde('b2b:verifiziert', id);
  }

  function alsAngefragt(id) {
    merke('vr_requested_' + id, Date.now());
    melde('b2b:verify-angefragt', id);
  }

  /** Antwort des Servers anwenden — fuer status() und send() dieselbe Stelle. */
  function anwenden(id, data) {
    if (!data || !data.success) return data;
    if (data.verified || data.alreadyVerified) {
      alsVerifiziert(id);
    } else if (data.requested === false) {
      vergiss('vr_requested_' + id);   // erledigt/abgelehnt: der Knopf darf wieder
    } else {
      alsAngefragt(id);
    }
    return data;
  }

  function post(k, extra) {
    var body = { email: k.email, customerId: k.customerId };
    for (var x in extra) body[x] = extra[x];
    return fetch(k.apiBase + '/api/b2b/verify-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  window.B2BVerify = {
    angefragt: function (id) {
      try { return !!localStorage.getItem('vr_requested_' + id); } catch (e) { return false; }
    },
    status: function () {
      if (anfrage) return anfrage;
      var k = wer();
      if (!k) return (anfrage = Promise.resolve(null));
      var schluessel = 'vr_status_' + k.customerId;
      try {
        var alt = JSON.parse(sessionStorage.getItem(schluessel) || 'null');
        // ⚠️ Ueber .then, nicht direkt: die Ereignisse muessen NACH dem Anmelden der Zuhoerer kommen.
        if (alt && Date.now() - alt.t < FRISCH_MS) {
          return (anfrage = Promise.resolve(alt.d).then(function (d) { return anwenden(k.customerId, d); }));
        }
      } catch (e) {}
      anfrage = post(k, { nurStatus: true })
        .then(function (data) {
          if (data && data.success && !data.verified) {
            try { sessionStorage.setItem(schluessel, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
          }
          return anwenden(k.customerId, data);
        })
        .catch(function () { return null; });
      return anfrage;
    },
    send: function () {
      var k = wer();
      if (!k) return Promise.reject(new Error('kein Login'));
      return post(k, {}).then(function (data) {
        try { sessionStorage.removeItem('vr_status_' + k.customerId); } catch (e) {}
        return anwenden(k.customerId, data);
      });
    }
  };

  // ── Leiste ──────────────────────────────────────────────────────────────────
  var bar = document.getElementById('vr-bar');
  if (!bar) return;
  var id = bar.getAttribute('data-customer');
  if (!id) return;   // nicht unverifiziert → nichts zu tun

  // Auch wenn die Leiste wegen "×" oder "schon gesendet" verborgen ist: den echten Stand
  // holen, damit die Sitzung nachgefuehrt wird und die Konto-Karte stimmt.
  window.B2BVerify.status();
  document.addEventListener('b2b:verifiziert', function () { bar.hidden = true; });

  if (bar.hidden) return;

  var btn = document.getElementById('vr-btn');
  var txt = document.getElementById('vr-text');
  var close = document.getElementById('vr-close');
  var gesendet = false;

  /** Gleiches Format wie im Snippet: lokales Datum ohne fuehrende Nullen. */
  function heute() {
    var d = new Date();
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  function zeigeGesendet() {
    if (gesendet) return;
    gesendet = true;
    bar.classList.add('vr-bar--sent');
    var icon = bar.querySelector('.vr-bar__icon');
    if (icon) icon.innerHTML = '<circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-6"/>';
    txt.innerHTML = '<span class="vr-bar__long">' + bar.getAttribute('data-sent') + '</span>'
      + '<span class="vr-bar__short">' + bar.getAttribute('data-sent-short') + '</span>';
    btn.hidden = true;
    var zu = bar.getAttribute('data-close-sent');
    close.title = zu;
    close.setAttribute('aria-label', zu);
  }

  function zeigeFehler() {
    btn.disabled = false;
    btn.innerHTML = btn.getAttribute('data-label');
    var alt = txt.querySelector('.vr-bar__error');
    if (alt) alt.remove();
    var f = document.createElement('span');
    f.className = 'vr-bar__error';
    f.textContent = bar.getAttribute('data-error');
    txt.appendChild(f);
  }

  btn.setAttribute('data-label', btn.innerHTML);
  document.addEventListener('b2b:verify-angefragt', zeigeGesendet);

  btn.addEventListener('click', function () {
    btn.disabled = true;
    btn.textContent = bar.getAttribute('data-sending');

    window.B2BVerify.send()
      .then(function (data) {
        // Erfolg: anwenden() hat 'b2b:verifiziert' oder 'b2b:verify-angefragt' gemeldet.
        if (!data || !data.success) zeigeFehler();
      })
      .catch(zeigeFehler);
  });

  close.addEventListener('click', function () {
    if (!gesendet) {
      merke('vr_snooze_' + id, JSON.stringify({ tag: heute(), sitzung: bar.getAttribute('data-sitzung') || '' }));
    }
    bar.hidden = true;
  });
})();
